// removed by extract-text-webpack-plugin
module.exports = {"font-header":"Trustee-module__font-header__1nveF","fontHeader":"Trustee-module__font-header__1nveF","font-primary":"Trustee-module__font-primary__22Y6i","fontPrimary":"Trustee-module__font-primary__22Y6i","font-secondary":"Trustee-module__font-secondary__33sCr","fontSecondary":"Trustee-module__font-secondary__33sCr","sr-only":"Trustee-module__sr-only__1p9kU","srOnly":"Trustee-module__sr-only__1p9kU","sr-only-important":"Trustee-module__sr-only-important__3KXdr","srOnlyImportant":"Trustee-module__sr-only-important__3KXdr","pageFormDescription":"Trustee-module__pageFormDescription__2TMQX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Onboarding/TrusteeForm/Trustee.module.scss
// module id = 712
// module chunks = 0